import {computed, makeObservable} from "mobx";
import SaporeForm from "../forms/SaporeForm";
import TextField from "../forms/fields/TextField";
import NumberField from "../forms/fields/NumberField";

export default class CustomerContactForm extends SaporeForm {
    static newEmpty(feature = null, configuration) {
        const initialData = {
            collectionsContactName: '',
            collectionsContactEmail: '',
            collectionsContactPhoneNumber: '',
            collectionsContactAreaNumber: '',
            ordersContactName: '',
            ordersContactEmail: '',
            ordersContactPhoneNumber: '',
            ordersContactAreaNumber: ''
        };
        return new CustomerContactForm(initialData, feature, configuration);
    }

    static newFor(customerContact = null, feature = null, configuration) {
        return new CustomerContactForm(customerContact, feature, configuration);
    }

    constructor(initialData = {}, feature = null, configuration) {
        const form = super({}, null, feature, configuration);

        const fields = {
            collectionsContactName: new TextField(1, 100, this.isOptional('collectionsContactName'), initialData.collectionsContactName, feature),
            collectionsContactEmail: new TextField(1, 100, this.isOptional('collectionsContactEmail'), initialData.collectionsContactEmail, feature),
            collectionsContactPhoneNumber: new NumberField(6, 8, this.isOptional('collectionsContactPhoneNumber'), initialData.collectionsContactPhoneNumber, feature),
            collectionsContactAreaNumber: new NumberField(2, 4, this.isOptional('collectionsContactAreaNumber'), initialData.collectionsContactAreaNumber, feature),
            ordersContactName: new TextField(1, 100, this.isOptional('ordersContactName'), initialData.ordersContactName, feature),
            ordersContactEmail: new TextField(1, 100, this.isOptional('ordersContactEmail'), initialData.ordersContactEmail, feature),
            ordersContactPhoneNumber: new NumberField(6, 8, this.isOptional('ordersContactPhoneNumber'), initialData.ordersContactPhoneNumber, feature),
            ordersContactAreaNumber: new NumberField(2, 4, this.isOptional('ordersContactAreaNumber'), initialData.ordersContactAreaNumber, feature)
        };

        form.setFields(fields);

        makeObservable(this, {
            collectionsContactNameValue: computed,
            collectionsContactEmailValue: computed,
            collectionsContactPhoneNumberValue: computed,
            collectionsContactAreaNumberValue: computed,
            ordersContactNameValue: computed,
            ordersContactEmailValue: computed,
            ordersContactPhoneNumberValue: computed,
            ordersContactAreaNumberValue: computed,
        });
    }

    configurationFieldNameMapping() {
        return {
            collectionsContactName: '_collections_contact_name',
            collectionsContactEmail: '_collections_contact_email',
            collectionsContactAreaNumber: '_collections_contact_area_number',
            collectionsContactPhoneNumber: '_collections_contact_phone_number',
            ordersContactName: '_orders_contact_name',
            ordersContactEmail: '_orders_contact_email',
            ordersContactAreaNumber: '_orders_contact_area_number',
            ordersContactPhoneNumber: '_orders_contact_phone_number',
        }
    }

    collectionsContactName() {
        return this.getFieldByName('collectionsContactName').value;
    }

    collectionsContactEmail() {
        return this.getFieldByName('collectionsContactEmail').value;
    }

    collectionsContactPhoneNumber() {
        return this.getFieldByName('collectionsContactPhoneNumber').value;
    }

    collectionsContactAreaNumber() {
        return this.getFieldByName('collectionsContactAreaNumber').value;
    }

    ordersContactName() {
        return this.getFieldByName('ordersContactName').value;
    }

    ordersContactEmail() {
        return this.getFieldByName('ordersContactEmail').value;
    }

    ordersContactPhoneNumber() {
        return this.getFieldByName('ordersContactPhoneNumber').value;
    }

    ordersContactAreaNumber() {
        return this.getFieldByName('ordersContactAreaNumber').value;
    }

    get collectionsContactNameValue() {
        return this.collectionsContactName();
    }

    get collectionsContactEmailValue() {
        return this.collectionsContactEmail();
    }

    get collectionsContactPhoneNumberValue() {
        return this.collectionsContactPhoneNumber();
    }

    get collectionsContactAreaNumberValue() {
        return this.collectionsContactAreaNumber();
    }

    get ordersContactNameValue() {
        return this.ordersContactName();
    }

    get ordersContactEmailValue() {
        return this.ordersContactEmail();
    }

    get ordersContactPhoneNumberValue() {
        return this.ordersContactPhoneNumber();
    }

    get ordersContactAreaNumberValue() {
        return this.ordersContactAreaNumber();
    }
}
